import { Deserializable } from "./deserializable.model";
import { WorkerActivityData } from "./worker-activity-data.model";

export class WorkerActivity implements Deserializable {
    id?: number | string;
    worker_id: number | string;
    item_id: number | string;
    item_lot: string;              // ODP Batch
    production_order_id: number | string;
    production_order_code: string;
    mbom_row_id: number | string;
    phase_id: number | string;
    phase_name: string;
    worker_activity_type: any;      // Activity type    
    job?: string;                   // Activity Job
    process?: string;               // Activity Process
    passes?: number | string;       // Degreasing/Finishing passes      
    start_date: Date;               // Start date
    end_date: Date;                 // End date    
    quantity_done: number | string; // Qty done
    data: WorkerActivityData;       // Worker Activity Data
    note?: string;
    endJob?: number;

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}